import { useState } from 'react';

const usePathId = (): [string | undefined, (pathId: string) => void] => {
  const [pathId, setPathId] = useState<string | undefined>(undefined);

  const onSetPathId = (pathId: string) => setPathId(pathId);

  return [pathId, onSetPathId];
};

export default usePathId;
